// tslint:disable
export enum EligibilityScope {
    /**
     * @description All
     */
    All = 4294967295,
    /**
     * @description Survey
     */
    Survey = 1,
    /**
     * @description Patient
     */
    Patient = 2,
    /**
     * @description Income
     */
    Income = 4,
}
(EligibilityScope as any)['ALL'] = 4294967295;
(EligibilityScope as any)['SURVEY'] = 1;
(EligibilityScope as any)['PATIENT'] = 2;
(EligibilityScope as any)['INCOME'] = 4;
